import { useInfiniteQuery as e } from "@tanstack/react-query";
//#region src/hooks/useInfiniteQuery.ts
function t(t) {
	return e(t);
}
//#endregion
export { t as useInfiniteQuery };
